import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './config/router'
import axios from "./config/http"
import VueAxios from "vue-axios";
import VueNoty from 'vuejs-noty'
import 'vuejs-noty/dist/vuejs-noty.css'
import VCharts from 'v-charts'

Vue.config.productionTip = false

Vue.use(VCharts);
Vue.use(VueAxios,axios);
Vue.use(VueNoty, {
    timeout: 3000,
    progressBar: true,
    theme: 'sunset',
    layout: 'topCenter'
});

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
